import { useContext } from 'react';
import NonInteractiveViewerContext from '../state/NonInteractiveViewerContext';

/**
 * A non-interactive viewer covers:
 * - bots
 * - bread endpoints
 *
 * This system is (typically) used to disable performance optimizations in other areas of the application
 * that are great for humans but make bot life challenging.
 *
 */
const useIsNonInteractiveViewer = (): boolean =>
  useContext(NonInteractiveViewerContext) ?? false;

export default useIsNonInteractiveViewer;
